import { __assign } from "tslib";
import { ConductionMethod } from '../conduction-method';
export var GlobalDefaultKeys = {
    UseNewApi: '__WIXEXP_USE_NEW_API',
    ConductionMethod: '__WIXEXP_CONDUCTION_METHOD_',
    OwnerAccountId: '__WIXEXP_OWNER_ACCOUNT_ID_',
    LoggedInUserId: '__WIXEXP_LOGGED_IN_USER_ID_',
};
function getValueOrEmptyObject(objectKey, globalValueKey, type) {
    var _a, _b;
    if (typeof self !== 'undefined') {
        if (typeof type === 'function') {
            if (typeof type(self[globalValueKey]) !== 'undefined') {
                return _a = {}, _a[objectKey] = type(self[globalValueKey]), _a;
            }
        }
        else if (typeof self[globalValueKey] === type) {
            return _b = {}, _b[objectKey] = self[globalValueKey], _b;
        }
    }
    return {};
}
var checkConductionMethod = function (conductionMethod) {
    return Object.keys(ConductionMethod).filter(function (cm) { return ConductionMethod[cm] === conductionMethod; }).length > 0
        ? conductionMethod
        : undefined;
};
export function getGlobalDefaults() {
    return __assign(__assign(__assign(__assign({}, getValueOrEmptyObject('useNewApi', GlobalDefaultKeys.UseNewApi, 'boolean')), getValueOrEmptyObject('conductionMethod', GlobalDefaultKeys.ConductionMethod, checkConductionMethod)), getValueOrEmptyObject('siteOwnerId', GlobalDefaultKeys.OwnerAccountId, 'string')), getValueOrEmptyObject('loggedInUserId', GlobalDefaultKeys.LoggedInUserId, 'string'));
}
//# sourceMappingURL=global-defaults.js.map